import { render, staticRenderFns } from "./selectTag.vue?vue&type=template&id=12d22ed6&scoped=true"
import script from "./selectTag.vue?vue&type=script&lang=js"
export * from "./selectTag.vue?vue&type=script&lang=js"
import style0 from "./selectTag.vue?vue&type=style&index=0&id=12d22ed6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d22ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d22ed6')) {
      api.createRecord('12d22ed6', component.options)
    } else {
      api.reload('12d22ed6', component.options)
    }
    module.hot.accept("./selectTag.vue?vue&type=template&id=12d22ed6&scoped=true", function () {
      api.rerender('12d22ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/components/selectTag.vue"
export default component.exports